// Global download notification store.
// Any module can report a download here; DownloadStack renders the notifications.
const listeners = new Set();
let downloads = [];
let counter = 0;

const emit = () => {
    const snapshot = downloads;
    listeners.forEach(listener => listener(snapshot));
};

export const subscribeToDownloadNotifications = (listener) => {
    listeners.add(listener);
    listener(downloads);
    return () => listeners.delete(listener);
};

export const beginDownloadNotification = (fileName) => {
    counter += 1;
    const id = `download-${Date.now()}-${counter}`;
    downloads = [...downloads, {
        id,
        fileName: fileName || 'Download',
        status: 'loading',
        createdAt: Date.now()
    }];
    emit();
    return id;
};

export const markDownloadNotificationStarted = (id) => {
    downloads = downloads.map(item => item.id === id ? { ...item, status: 'started' } : item);
    emit();
};

export const dismissDownloadNotification = (id) => {
    downloads = downloads.filter(item => item.id !== id);
    emit();
};
